import Rails from "@rails/ujs"

document.addEventListener("change", function(event) {
  const element = event.target
  
  if (element.dataset.behavior && element.dataset.behavior.includes('submits_closest_form_on_change')) {
    const form = element.closest('form')
    
    if (form) {
      Rails.fire(form, 'submit')
    } else {
      console.warn("Expected to find a form near", element)
    }
  }
})